import React from 'react';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import classNames from 'classnames';

export default class QuickShopOptionValue extends React.Component {
  static propTypes = {
    optionValue: propTypes.oneOfType([propTypes.string, propTypes.number]),
    optionValueLabel: propTypes.oneOfType([propTypes.string, propTypes.object]),
    optionType: propTypes.string,
    selectedVariant: accountPropTypes.ProductVariant,
    pendingVariant: accountPropTypes.ProductVariant,
    changeSelectedVariant: propTypes.func.isRequired,
  };

  render() {
    const {
      optionValue,
      optionValueLabel,
      optionType,
      selectedVariant,
      pendingVariant,
      changeSelectedVariant,
    } = this.props;

    const disabled = !pendingVariant;

    return (
      <label
        className={classNames('quickShop-option', {
          checked: selectedVariant[optionType] === optionValue,
          disabled,
        })}
      >
        <input
          type="radio"
          onChange={() => changeSelectedVariant(pendingVariant)}
          value={optionValue}
          checked={selectedVariant[optionType] === optionValue}
          className={'hide'}
          disabled={disabled}
        />
        {optionValueLabel}
      </label>
    );
  }
}
